// 設定: ログイン中のメール・所属事業所・ログアウト。
import { useNavigate } from 'react-router';
import { LogOut } from 'lucide-react';
import { clearSession, loadSession } from '../lib/auth';
import { OFFICE_KEY, useOffice } from '../lib/office';
import { Badge, Button, Card, ErrorText, Loading, PageTitle } from '../components/ui';

const ROLE_LABEL: Record<string, string> = { office_admin: '事業所管理者', corp_admin: '法人担当者', operator: '運営' };

export function SettingsPage() {
  const navigate = useNavigate();
  const { me, loading, error, officeId } = useOffice();
  const session = loadSession();

  const logout = () => {
    clearSession();
    try {
      localStorage.removeItem(OFFICE_KEY);
    } catch {
      // 消せなくてもログイン画面へ
    }
    navigate('/login', { replace: true });
  };

  return (
    <>
      <PageTitle>設定</PageTitle>
      <div className="space-y-4">
        <Card className="space-y-1">
          <div className="text-sm text-ink-3">ログイン中のメールアドレス</div>
          <div data-testid="settings-email" className="font-medium">{session?.email ?? '不明'}</div>
        </Card>
        <Card className="space-y-2">
          <div className="text-sm text-ink-3">所属している事業所</div>
          {loading ? <Loading /> : null}
          <ErrorText>{error}</ErrorText>
          {me?.principal.offices.length === 0 ? <p className="text-ink-2">所属している事業所はありません。</p> : null}
          <ul className="space-y-1.5">
            {me?.principal.offices.map((o) => (
              <li key={o.officeId} className="flex flex-wrap items-center gap-2">
                <span className="font-medium">{o.officeName}</span>
                <span className="text-sm text-ink-3">{o.corpName}</span>
                {o.officeId === officeId ? <Badge tone="accent">選択中</Badge> : null}
              </li>
            ))}
          </ul>
          {me && me.principal.roles.length > 0 ? (
            <div className="flex flex-wrap gap-1.5 pt-1">
              {me.principal.roles.map((r, i) => (
                <Badge key={i}>{ROLE_LABEL[r.role] ?? r.role}</Badge>
              ))}
            </div>
          ) : null}
        </Card>
        <Button data-testid="logout" variant="secondary" onClick={logout}>
          <LogOut size={16} />
          ログアウト
        </Button>
      </div>
    </>
  );
}
